const helpVideosBundle = {
    courses: [
        { id: 100000, title: 'helplist:create_course_complete_tutorial', route: 'Sharelook AI Course Creation Complete Tutorial', videoUrl: 'https://www.youtube.com/embed/Vn0enwrQzfo?si=kYiE9zU_OQuAc3aU', createdDate: '2025-11-17', description: 'helplist:create_course_complete_tutorial_desc' }
    ],
};

// add a slug-based route
Object.keys(helpVideosBundle).forEach(category => {
    helpVideosBundle[category] = helpVideosBundle[category].map(video => ({
        ...video,
        route: video.route
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-')
    }))
})

export default helpVideosBundle
